import { observable } from 'mobx'

class FilterStore {
  @observable
  customFilterGroup = ''
}

export default new FilterStore()
